import Vue from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './routes'
import store from './store'
import './bootstrap'
 import Vuetify from 'vuetify'
 import 'vuetify/dist/vuetify.min.css'
 Vue.use(Vuetify)
 const opts = {}
 const vuetify= new Vuetify(opts)
Vue.config.productionTip = false;

new Vue({
	router,
  store,
  vuetify,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js